module.exports = __webpack_public_path__ + "img/specialist-schedule-hover.bbf6ef04.svg";